export class UpdateFertilizerByIdUseCase {
  constructor(api){
    this.api=api
  }
  async execute(farm) {
    const {
      ID,
      NAME,
      DILUTION,
      COMPOSITION,
      isEspecial,
      NOTE
    }=farm
    const raw = `
      UPDATE CROP.FERTILIZER
      SET NAME="${NAME}", DILUTION=${DILUTION}, COMPOSITION="${COMPOSITION}", isEspecial=${isEspecial}, NOTE="${NOTE}"
      WHERE ID=${ID};
    `
    const resp= await this.api.sql({
      data:{
        sql:raw
      }
    })

    return resp
  }
}
